module.exports = __webpack_public_path__ + "static/media/img6.fb31ae53.jpg";